class Slider

  defOpts =
    option:
      arrows        : true
      dots          : false
      slidesToShow  : 1
      adaptiveHeight: false
      initialSlide  : 0
      responsive    : [
        {
          breakpoint: 1000
        }
      ]

  constructor: (elm, opts = {}) ->
    { @option, @boxHeight } = _.defaultsDeep opts, defOpts

    @$elm = $ elm
    @$elm
      .on
        'init breakpoint': @init
        'slideReset': @slideReset
      .slick @option

  init: (event, slick, evenst) =>
    return true unless @boxHeight
    maxHight = []
    _.forEach slick.$slides , (elm, i) ->
      $elm = $ elm
      $elm.css 'height', 'auto'
      maxHight.push $elm.height()
    height = _.max maxHight
    slick.$slideTrack.children().height height

  slideReset: (event) =>
    $items = @$elm.find('.slick-track').children()
    maxHight = []
    _.forEach $items , (elm, i) ->
      $elm = $ elm
      $elm.css 'height', 'auto'
      maxHight.push $elm.height()
    height = _.max maxHight
    $items.height height
    @$elm.slick 'setPosition'

export default Slider



// WEBPACK FOOTER //
// ./webpack/imports/view/slider.coffee